import { useState } from 'react'
import SiteFooter from '../components/SiteFooter'
import SiteHeader from '../components/SiteHeader'
import SiteBackdrop from '../components/SiteBackdrop'

const themes = [
  {
    name: 'Canyon Run',
    label: 'PERFORMANCE',
    description: 'Warm guidance, live telemetry, and the essential controls for a focused mountain drive.',
    color: '#F58F7C',
  },
  {
    name: 'Night Dispatch',
    label: 'PROFESSIONAL',
    description: 'A low-distraction workspace for routes, schedules, documents, and vehicle status after dark.',
    color: '#F2C4CE',
  },
  {
    name: 'Quiet Commute',
    label: 'EVERYDAY',
    description: 'Calendar context, familiar music, weather, and one clean route for the daily drive.',
    color: '#D6D6D6',
  },
]

const agents = [
  ['Route Scout', 'Navigation', 'Monitors the active route and useful stops without interrupting the drive.'],
  ['Vehicle Watch', 'Vehicle health', 'Keeps diagnostics and maintenance context close to the current trip.'],
  ['Road Brief', 'Communication', 'Turns calendars, messages, and documents into a concise pre-drive brief.'],
] as const

export default function CommunityPage() {
  const [activeTheme, setActiveTheme] = useState(themes[0].name)

  return (
    <div className="community-shell">
      <SiteBackdrop />
      <SiteHeader />
      <main className="community-main">
        <section className="community-hero" aria-labelledby="community-title">
          <p className="eyebrow">BUILT AROUND THE WAY PEOPLE DRIVE</p>
          <h1 id="community-title">Make the stack yours.</h1>
          <p>
            Explore Road Stack themes, Drive Packs, and agents designed for different
            vehicles, trips, and workflows.
          </p>
          <div className="hero-rail" aria-hidden="true" />
        </section>

        <section className="community-section" aria-labelledby="themes-title">
          <div className="section-heading">
            <p className="eyebrow">COMMUNITY THEMES</p>
            <h2 id="themes-title">A cockpit for every kind of drive.</h2>
          </div>
          <div className="theme-grid">
            {themes.map((theme) => {
              const active = activeTheme === theme.name
              return (
                <button
                  type="button"
                  className={active ? 'theme-card theme-card--active' : 'theme-card'}
                  key={theme.name}
                  onClick={() => setActiveTheme(theme.name)}
                  aria-pressed={active}
                >
                  <span className="theme-preview" style={{ '--theme-accent': theme.color } as React.CSSProperties}>
                    <span className="theme-route" />
                    <span className="theme-turn">↱</span>
                    <span className="theme-distance">200 ft</span>
                    <span className="theme-instruction">Turn right onto W 9th St</span>
                  </span>
                  <span className="card-kicker">{theme.label}</span>
                  <strong>{theme.name}</strong>
                  <span>{theme.description}</span>
                </button>
              )
            })}
          </div>
        </section>

        <section className="community-section agents-section" aria-labelledby="agents-title">
          <div className="section-heading">
            <p className="eyebrow">ROAD STACK AGENTS</p>
            <h2 id="agents-title">Useful context, handled quietly.</h2>
          </div>
          <div className="agent-list">
            {agents.map(([name, category, description], index) => (
              <article className="agent-card" key={name}>
                <span className="agent-index">{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <p>{category}</p>
                  <h3>{name}</h3>
                  <span>{description}</span>
                </div>
                <span className="agent-status">READY</span>
              </article>
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  )
}
